import React from "react";

import { Row, Col } from "react-bootstrap";

import "../styles/util.css";
//import "../styles/custom_bootstrap.css";

function RowGrid({ ancho, text1, text2 }) {
  return (
    <>
      <Row className="mb-1">
        <Col xs={ancho} className="txt-bold ">{text1}</Col>
        <Col className="textoUppercase">{text2}</Col>
      </Row>
    </>
  );
}
export default RowGrid;
